module.exports = __webpack_public_path__ + "img/1_1-commerciale-panettiere-2.b7bebb49.png";